module.exports = __webpack_public_path__ + "img/idea-planIcon.c3873358.svg";